import { DatePicker } from 'antd';
import {
  DAY,
  RANGE_PRESETS,
  isOutOfRange,
  type StatsRange,
} from './statsRange';

type Props = {
  value: StatsRange;
  onChange: (next: StatsRange) => void;
};

/** Day range within the backend's window: up to today (UTC), 90 days back. */
export const StatsRangePicker = ({ value, onChange }: Props) => (
  <DatePicker.RangePicker
    allowClear={false}
    value={value}
    format={DAY}
    disabledDate={isOutOfRange}
    presets={RANGE_PRESETS}
    onChange={(dates) => {
      if (!dates?.[0] || !dates?.[1]) return;
      onChange([dates[0], dates[1]]);
    }}
  />
);
